export default __webpack_public_path__ + "static/e-commerce-catalog-38a33d5fb779e31fc9486ad61ef808b7.gif";